import R from 'ramda';
import { getBreakpoints, isMobileBreakpoint } from '../breakpointHelper';
import { getWindow } from '../../../helpers/globals';

export const SET_BREAKPOINTS = 'BEAMLY/CCX/SET_BREAKPOINTS';
export const SET_CURRENT_BREAKPOINT = 'BEAMLY/CCX/SET_CURRENT_BREAKPOINT';
export const SET_IS_MOBILE = 'BEAMLY/CCX/SET_IS_MOBILE';

export const setCurrentBreakpoint = name => ({
  type: SET_CURRENT_BREAKPOINT,
  name,
});

export const setBreakpoints = breakpoints => ({
  type: SET_BREAKPOINTS,
  breakpoints,
});

export const setIsMobile = isMobile => ({
  type: SET_IS_MOBILE,
  isMobile,
});

export const listenForBreakpointChanges = ({ mobileConditionBreakpointsArray }) => (dispatch, getState) => {
  const breakpoints = R.pathOr({}, ['breakpoints', 'breakpoints'])(getState());

  getBreakpoints(breakpoints).forEach(({ name, mediaQueryString }) => {
    const mediaQuery = getWindow().matchMedia(mediaQueryString);

    mediaQuery.addListener((e) => {
      if (e.matches) {
        dispatch(setCurrentBreakpoint(name));
        dispatch(setIsMobile(isMobileBreakpoint({ name, mobileConditionBreakpointsArray })));
      }
    });

    if (mediaQuery.matches) {
      dispatch(setCurrentBreakpoint(name));
      dispatch(setIsMobile(isMobileBreakpoint({ name, mobileConditionBreakpointsArray })));
    }
  });
};
